import { RxGear } from "react-icons/rx";

const GearIcon = ({ size }) => {
  return <RxGear className="no-shrink" size={size} />;
};

export default GearIcon;
